import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AlertCircle, RefreshCw } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { authService } from '../services/authService';
import { handleCallback, forgetKeycloakSession } from '../auth/keycloak';

// Keycloak redirects here after Microsoft sign-in: exchange the code, then swap the Keycloak token
// for Nexus tokens at POST /auth/sso.
const SsoCallbackPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { setSession } = useAuth();
    const [error, setError] = useState('');
    const started = useRef(false); // StrictMode runs effects twice; the code is single-use

    useEffect(() => {
        if (started.current) return;
        started.current = true;
        (async () => {
            try {
                const accessToken = await handleCallback(location.search);
                const result = await authService.sso(accessToken);
                setSession(result.data || result);
                navigate('/dashboard', { replace: true });
            } catch (err) {
                forgetKeycloakSession();
                setError(err.message || 'Microsoft sign-in failed');
            }
        })();
    }, []);

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-start justify-center pt-32 p-4">
            <div className="w-full max-w-md bg-white rounded-2xl shadow-xl p-8 text-center">
                {error ? (
                    <>
                        <div className="bg-red-50 border border-red-200 text-red-700 p-3 rounded-lg flex items-center gap-2 text-left">
                            <AlertCircle className="w-5 h-5 flex-shrink-0" />
                            <span className="text-sm">{error}</span>
                        </div>
                        <button
                            onClick={() => navigate('/login', { replace: true })}
                            className="mt-6 w-full bg-blue-600 text-white font-semibold py-3 rounded-lg hover:bg-blue-700 transition"
                        >
                            Back to sign in
                        </button>
                    </>
                ) : (
                    <>
                        <RefreshCw className="w-10 h-10 text-blue-600 animate-spin mx-auto mb-4" />
                        <p className="text-gray-600">Signing you in…</p>
                    </>
                )}
            </div>
        </div>
    );
};

export default SsoCallbackPage;
